// client/src/v2/components/sidebar/SchoolRow.jsx

import React from "react";
import { usePressWithoutScroll } from "../usePressWithoutScroll";
import HeartIcon from "./HeartIcon";
import { isFaithPrioritySchool } from "../../utils/openCatchmentAccess";

export default function SchoolRow({
  school,
  checked,
  onToggle,
  onOpenTransport,
  hoverTitle: _hoverTitle, // kept for callers; tooltip is name + optional Open seats
  onOpenDetails, // ✅ additive
  onRowClick, // ✅ additive: close drawer when clicking another school
  /** Phone lists: row selects the school; only the › button opens the drawer. */
  rowOpensDrawer = true,
  isDrawerOpen, // › button active
  isTransportOpen, // bus button active
  isCatchmentSelected, // checkbox on (catchment on map)
  /** True when this school is the map pan/ring focus (drawer, transport, or last row focus). */
  isMapFocused = false,
  isFavourite = false,
  onToggleFavourite,
  /** Schools Open To All: append "(N)" when open seat quota is known. */
  showOpenSeatsBracket = false,
}) {
  const isCatchmentOnly =
    isCatchmentSelected && !isMapFocused;

  const faithPriority =
    showOpenSeatsBracket && isFaithPrioritySchool(school);

  const rowClass = [
    "v2-school-row",
    isMapFocused ? "v2-school-row--focused" : "",
    isCatchmentOnly ? "v2-school-row--catchment-only" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const nameClass = [
    "v2-school-name",
    faithPriority ? "v2-school-name--faith" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const toggleCatchment = () => onToggle?.(school.id);
  const press = usePressWithoutScroll(() => {
    if (checked) {
      toggleCatchment();
      if (rowOpensDrawer && isDrawerOpen) onOpenDetails?.(school);
      return;
    }
    toggleCatchment();
    onRowClick?.(school);
    if (rowOpensDrawer && !isDrawerOpen) onOpenDetails?.(school);
  });

  return (
    <div
      className={rowClass}
      onPointerDown={press.onPointerDown}
      onClick={press.onClick}
    >
      <div className="v2-school-row-left">
        <input
          type="checkbox"
          checked={checked}
          aria-label={`Show catchment for ${school.name}`}
          // Stop bubble so we don't toggle twice (input change + row click)
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            e.stopPropagation();
            toggleCatchment();
          }}
        />

        <span className={nameClass}>
          {school.name}
        </span>
      </div>

      <div className="v2-school-actions">
        <button
          type="button"
          className={`v2-icon-btn${isFavourite ? " v2-icon-btn--favourite" : ""}`}
          title={isFavourite ? "Remove favourite" : "Add favourite"}
          aria-pressed={isFavourite}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggleFavourite?.(school.id);
          }}
        >
          {isFavourite ? <HeartIcon active /> : <HeartIcon />}
        </button>

        <button
          type="button"
          className={`v2-icon-btn${isTransportOpen ? " v2-icon-btn--active" : ""}`}
          title="Transport"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRowClick?.(school);
            onOpenTransport?.(school);
          }}
        >
          🚌
        </button>

        <button
          type="button"
          className={`v2-icon-btn v2-icon-btn--details${isDrawerOpen ? " v2-icon-btn--active" : ""}`}
          title="More"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onOpenDetails?.(school);
          }}
        >
          ›
        </button>
      </div>
    </div>
  );
}